import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "s20 widget bg-color-1000 text-white px-7 py-7 rounded-40" }
const _hoisted_3 = {
  class: "flex align-items-center gap-4 mb-4",
  style: {"justify-content":"space-between","flex-wrap":"wrap"}
}
const _hoisted_4 = { class: "s4_mobile px-2" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s6_mobile px-5 mt-5" }
const _hoisted_7 = { class: "secondary-font mb-4" }
const _hoisted_8 = { class: "secondary-font font-normal mb-3" }
const _hoisted_9 = { class: "secondary-font mb-4" }
const _hoisted_10 = { class: "s5_mobile px-3 mt-5" }
const _hoisted_11 = { class: "secondary-font mb-4" }
const _hoisted_12 = { class: "secondary-font mb-4" }
const _hoisted_13 = {
  key: 0,
  class: "s5_mobile px-3 mt-5"
}
const _hoisted_14 = { class: "secondary-font mb-4" }
const _hoisted_15 = { class: "secondary-font font-normal mb-2" }
const _hoisted_16 = { class: "secondary-font mb-4" }
const _hoisted_17 = { class: "secondary-font mb-4" }
const _hoisted_18 = {
  key: 0,
  class: "widget s20 bg-black text-white p-4 rounded-40 mt-5 px-7 py-7"
}
const _hoisted_19 = { class: "flex align-items-center gap-4 mb-4" }
const _hoisted_20 = {
  key: 0,
  class: "tag-state success ml-4"
}
const _hoisted_21 = {
  key: 1,
  class: "tag-state warning ml-4"
}
const _hoisted_22 = { class: "secondary-font mb-2" }
const _hoisted_23 = { class: "secondary-font text-primary-color" }
const _hoisted_24 = {
  key: 1,
  class: "clear-both h-30"
}
const _hoisted_25 = {
  key: 2,
  class: "s12"
}
const _hoisted_26 = ["for"]
const _hoisted_27 = { class: "s1 mt-1" }
const _hoisted_28 = ["id", "value", "checked"]
const _hoisted_29 = { class: "s16 pl-2 secondary-font" }
const _hoisted_30 = { class: "secondary-font text-grey-600" }
const _hoisted_31 = { class: "s3 text-right" }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 0,
  class: "text-grey-600 mb-4"
}
const _hoisted_34 = {
  key: 3,
  class: "s1_mobile"
}
const _hoisted_35 = {
  key: 4,
  class: "s7_mobile"
}
const _hoisted_36 = { class: "secondary-font mb-4 text-grey-700 line-height-2-5" }
const _hoisted_37 = {
  class: "widget rounded-40 px-7 py-7",
  style: {"max-width":"500px","width":"90%","margin":"auto"}
}
const _hoisted_38 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[33] || (_cache[33] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-4" }, " Mon profil ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", {
          class: "secondary-font",
          style: {"margin":"0"}
        }, " Informations personnelles ", -1)),
        _createVNode(_component_router_link, {
          to: "/front/profil/informations-personnelles",
          class: "btn white2 active"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("img", {
              src: "/public/icons/icon-edit.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Modifier", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _ctx.profil?.photo_url || _ctx.profil?.avatar_url || _ctx.profil?.photo || _ctx.profil?.avatar || '/public/assets/users/300w/user2.jpg',
          width: "100%",
          class: "rounded-100 overflow-hidden item active"
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.profil?.prenom || '') + " ", 1),
          _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.profil?.nom || ''), 1)
        ]),
        _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.profil?.collectivite_nom || '-'), 1),
        (!_ctx.isGerant)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[11] || (_cache[11] = _createElementVNode("h6", { class: "secondary-font font-normal mb-2" }, " Ancienneté ", -1)),
              _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.profil?.anciennete || '-'), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[12] || (_cache[12] = _createElementVNode("h6", { class: "secondary-font font-normal mb-2" }, " Numéro de téléphone ", -1)),
        _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.maskedPhone), 1),
        _cache[13] || (_cache[13] = _createElementVNode("h6", { class: "secondary-font font-normal mb-2" }, " Adresse e-mail ", -1)),
        _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.maskedEmail), 1)
      ]),
      (!_ctx.isGerant)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _cache[14] || (_cache[14] = _createElementVNode("h6", { class: "secondary-font font-normal mb-2" }, " Salaire ", -1)),
            _createElementVNode("h6", _hoisted_14, _toDisplayString(_ctx.formatAmount(_ctx.profil?.salaire || 0)) + " F ", 1),
            _createElementVNode("h6", _hoisted_15, " Prélèvement " + _toDisplayString(_ctx.profil?.prelevement_pourcent || 0) + "% ", 1),
            _createElementVNode("h6", _hoisted_16, _toDisplayString(_ctx.formatAmount(_ctx.profil?.prelevement_montant || 0)) + " F ", 1),
            _cache[15] || (_cache[15] = _createElementVNode("h6", { class: "secondary-font font-normal mb-2" }, " Date d'engagement ", -1)),
            _createElementVNode("h6", _hoisted_17, _toDisplayString(_ctx.formatDateFrench(_ctx.profil?.date_engagement)), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isGerant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _cache[16] || (_cache[16] = _createElementVNode("img", {
              src: "/public/icons/icon-souscription.svg",
              class: "size-base icon-white",
              alt: ""
            }, null, -1)),
            _cache[17] || (_cache[17] = _createElementVNode("h4", { class: "secondary-font" }, " Ma Souscription ", -1)),
            (_ctx.souscription?.actif)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Active"))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, "Inactive"))
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("h6", { class: "secondary-font font-normal mb-2" }, " Mon revolving ", -1)),
          _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.formatAmount(_ctx.profil?.revolving || _ctx.souscription?.revolving || 0)) + " F ", 1),
          _createElementVNode("h6", _hoisted_23, " Valable jusqu'au " + _toDisplayString(_ctx.formatDateFrench(_ctx.souscription?.date_fin)), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isGerant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24))
      : _createCommentVNode("", true),
    (!_ctx.isGerant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "secondary-font mb-3" }, "Adresse de livraison", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adresses, (adresse) => {
            return (_openBlock(), _createElementBlock("div", {
              key: adresse.id,
              class: _normalizeClass(["card-check bg-white-50 widget flex my-2 py-5 px-6", { active: adresse.is_default }])
            }, [
              _createElementVNode("label", {
                class: "s20",
                for: 'adresse_' + adresse.id
              }, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("input", {
                    type: "radio",
                    name: "adresse",
                    id: 'adresse_' + adresse.id,
                    value: adresse.id,
                    checked: adresse.is_default
                  }, null, 8, _hoisted_28)
                ]),
                _createElementVNode("h5", _hoisted_29, [
                  _createTextVNode(_toDisplayString(adresse.libelle), 1),
                  _cache[20] || (_cache[20] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                  _createElementVNode("span", _hoisted_30, [
                    _createTextVNode(_toDisplayString(adresse.ville) + " " + _toDisplayString(adresse.commune) + " " + _toDisplayString(adresse.adresse), 1),
                    _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(adresse.telephone), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("img", {
                    src: adresse.is_default ? '/public/icons/icon-livraison-domicile.svg' : '/public/icons/icon-livraison-relais.svg',
                    class: "size-base",
                    alt: ""
                  }, null, 8, _hoisted_32)
                ])
              ], 8, _hoisted_26)
            ], 2))
          }), 128)),
          (_ctx.adresses.length === 0 && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Aucune adresse enregistrée "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn lg stroke w-100 flex-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddAddress = true))
          }, [...(_cache[21] || (_cache[21] = [
            _createElementVNode("span", null, "Ajouter une nouvelle adresse", -1)
          ]))]),
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isGerant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, " "))
      : _createCommentVNode("", true),
    (!_ctx.isGerant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _cache[26] || (_cache[26] = _createElementVNode("h2", { class: "secondary-font gap-4 mb-6" }, " Point relais ", -1)),
          _createElementVNode("h4", _hoisted_36, [
            _cache[24] || (_cache[24] = _createTextVNode(" Siège de la collectivité", -1)),
            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.profil?.collectivite_nom || '-'), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1)),
    (_ctx.showAddAddress)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "modal-overlay",
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.showAddAddress = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_37, [
            _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "secondary-font mb-5" }, "Créer une adresse de livraison", -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["form-field-floating reactive mb-4", { active: _ctx.newAddress.libelle }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newAddress.libelle) = $event)),
                type: "text",
                class: "form-field-input",
                id: "addr_libelle"
              }, null, 512), [
                [_vModelText, _ctx.newAddress.libelle]
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("label", {
                for: "addr_libelle",
                class: "form-field-label"
              }, [
                _createTextVNode("Nom de l'adresse "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["form-field-floating reactive mb-4", { active: _ctx.newAddress.ville }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newAddress.ville) = $event)),
                type: "text",
                class: "form-field-input",
                id: "addr_ville"
              }, null, 512), [
                [_vModelText, _ctx.newAddress.ville]
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("label", {
                for: "addr_ville",
                class: "form-field-label"
              }, [
                _createTextVNode("Ville "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["form-field-floating reactive mb-4", { active: _ctx.newAddress.commune }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newAddress.commune) = $event)),
                type: "text",
                class: "form-field-input",
                id: "addr_commune"
              }, null, 512), [
                [_vModelText, _ctx.newAddress.commune]
              ]),
              _cache[29] || (_cache[29] = _createElementVNode("label", {
                for: "addr_commune",
                class: "form-field-label"
              }, [
                _createTextVNode("Commune "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["form-field-floating reactive mb-4", { active: _ctx.newAddress.adresse }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newAddress.adresse) = $event)),
                type: "text",
                class: "form-field-input",
                id: "addr_adresse"
              }, null, 512), [
                [_vModelText, _ctx.newAddress.adresse]
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("label", {
                for: "addr_adresse",
                class: "form-field-label"
              }, [
                _createTextVNode("Adresse complète "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["form-field-floating reactive mb-4", { active: _ctx.newAddress.telephone }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newAddress.telephone) = $event)),
                type: "text",
                class: "form-field-input",
                id: "addr_telephone"
              }, null, 512), [
                [_vModelText, _ctx.newAddress.telephone]
              ]),
              _cache[31] || (_cache[31] = _createElementVNode("label", {
                for: "addr_telephone",
                class: "form-field-label"
              }, [
                _createTextVNode("Numéro de téléphone "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ], 2),
            _createElementVNode("button", {
              class: "btn lg w-100 flex-center",
              disabled: _ctx.savingAddress,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleCreateAddress && _ctx.handleCreateAddress(...args)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.savingAddress ? 'Enregistrement...' : 'Ajouter l\'adresse'), 1)
            ], 8, _hoisted_38)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}